import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(3, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1, 0),
  },
  '& .TRVBackBtn': {
    marginTop: theme.spacing(3),
  },
  '& .TRVReviewAdWidgetContiner': {
    marginTop: theme.spacing(1),
  },
}));

export default StyledBox;
